import React, { useState } from "react";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";
import "./rcSlider.css";

function RcSlider1({
  dotCount,
  value,
  skillsLevelHandlerRcSlider,
  indexArray,
  color,
  onBlur,
}) {
  return (
    <div>
      <div className="skill-rc_slider">
        <Slider
          onChange={(nextValues) => {
            skillsLevelHandlerRcSlider(nextValues, indexArray);

            // console.log("Change:", nextValues);
          }}
          onChangeComplete={(v) => {
            onBlur(true, "visual");
          }}
          min={1}
          max={10}
          //   defaultValue={50}
          value={value}
          step={1}
          //   dotStyle={{ borderColor: "orange" }}
          //   railStyle={{ backgroundColor: "red", height: 10 }}
          trackStyle={{ backgroundColor: color }}
        />
      </div>
    </div>
  );
}

export default RcSlider1;
